"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationButtons = exports.Description = exports.Title = exports.RequestCounter = exports.CloseButton = exports.NotificationItemWrapper = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var NotificationItemWrapper =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-ygdy0c0"
})("width:360px;background:#2c343f;padding:36px 36px 28px 36px;position:relative;box-sizing:border-box;");
exports.NotificationItemWrapper = NotificationItemWrapper;
var CloseButton =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-ygdy0c1"
})("position:absolute;top:20px;right:20px;cursor:pointer;");
exports.CloseButton = CloseButton;
var RequestCounter =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-ygdy0c2"
})("color:#808284;font-family:ChronicaPro;font-size:14px;letter-spacing:1px;text-transform:uppercase;");
exports.RequestCounter = RequestCounter;
var Title =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-ygdy0c3"
})("font-family:'Playfair Display';font-size:26px;line-height:36px;letter-spacing:0.22px;color:#ededed;padding-bottom:24px;");
exports.Title = Title;
var Description =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-ygdy0c4"
})("font-family:ChronicaPro;font-size:16px;font-weight:500;line-height:20px;color:", _themeConfig.default.color.dark.silver, ";padding-bottom:66px;");
exports.Description = Description;
var NavigationButtons =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-ygdy0c5"
})("position:absolute;top:20px;right:50px;svg{margin:0px 5.5px;cursor:pointer;fill:#ededed;}svg.disabled{opacity:0.3;cursor:default;}");
exports.NavigationButtons = NavigationButtons;